import { ReactQueryDevtools as e } from "./chunk426.js";
import { ReactQueryDevtoolsPanel as o } from "./chunk427.js";
var n = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : e;
process.env.NODE_ENV !== "development" || o;
export {
  n as ReactQueryDevtools
};
